<template>
  <div>
    <div class="text-center mb-4 flex justify-center">
      <p class="text-sm text-support-light mb-0">
        Do you want to host your images online?
        <v-icon
          v-tippy
          content="
            <p class='mb-2'>
              Host the images yourself or get us to host them for you <em>(only available on paid plans)</em>.
            </p>
            <p class='mb-2'>
              Choosing to host the images online with Promo is simple, fast and easy. The exported newsletter will just work.
            </p>
            <p class='mb-0'>
              If you choose to host the images yourself you will see an <code>img</code> folder in the downloaded zip file. You will then need to upload the images to an online hosting platform using FTP or a hosting file manager.
            </p>
          "
          class="help-icon"
          name="regular/question-circle"
          scale=".7"
        />
      </p>

      <div class="ml-2">
        <UiCheckbox
          :value="value"
          name="image-hosting"
          :disabled="downloading"
          @change="onUiCheckboxChange"
        />
      </div>
    </div>

    <transition name="fade">
      <div v-if="upgradeRequired" class="flex justify-center">
        <div class="upgrade-required">
          <p v-if="!loading" class="mb-0">
            <a :href="upgradeUrl" class="underline" @click="loading = true"
              >Upgrade Now</a
            >
            and host images
            <span v-if="plan.price">for just ${{ plan.price }} a month</span>
            with
            <UiInlineSelect
              class="border-b border-dashed border-support-lighter"
              @change="onSubscriptionChange"
            >
              <option value="Annual" :selected="subscription === 'Annual'"
                >annual</option
              >
              <option value="Monthly" :selected="subscription === 'Monthly'"
                >monthly</option
              >
            </UiInlineSelect>
            billing.
          </p>

          <p v-else class="mb-0">
            Loading Upgrade
            <v-icon name="spinner" class="loader" :scale="0.8" spin />
          </p>
        </div>
        <!-- .upgrade-required -->
      </div>
      <!-- .flex -->
    </transition>
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import UiCheckbox from "@/components/UI/UiCheckbox";
import UiInlineSelect from "@/components/UI/UiInlineSelect";

export default {
  name: "DownloadImageHosting",
  components: { UiCheckbox, UiInlineSelect },
  props: {
    downloading: {
      type: Boolean,
      default: false,
    },
    requiredPackage: {
      type: Object,
      default: null,
    },
    upgradeRequired: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // Data
    const loading = ref(false);
    const subscription = ref("Annual");
    const plan = computed(() =>
      props.requiredPackage?.plans
        ?.filter((plan) => plan.subscription === subscription.value)
        .reduce((acc) => acc)
    );
    const upgradeUrl = computed(() => plan.value?.upgradeUrl);

    // Methods
    const onSubscriptionChange = (sub) => (subscription.value = sub);

    const onUiCheckboxChange = (event) => {
      emit("input", event);
    };

    return {
      loading,
      onSubscriptionChange,
      onUiCheckboxChange,
      plan,
      subscription,
      upgradeUrl,
    };
  },
};
</script>

<style scoped>
.upgrade-required {
  @apply bg-info-light rounded-lg p-2 text-xs text-info-dark;

  @screen md {
    @apply p-3;
  }
}

.loader {
  @apply text-brand;
}
</style>
